import React from "react";
import H2 from "@/atoms/text/H2";
import Button from "@/atoms/Button";

export default function GrowBusiness({ title, cta, onClick }) {
  return (
    <section className="bc-grad-blue pv-8">
      <div className="container">
        <div className="fx fx--r-d fx--c fx--cv fx--sb-d">
          <H2
            color="white"
            desktopSize="md"
            className="ta-center bold mb-7 mb-reset-d"
            dangerouslySetInnerHTML={{ __html: title }}
          ></H2>
          <Button href={cta.href} size="md" onClick={onClick}>
            {cta.text}
          </Button>
        </div>
      </div>
    </section>
  );
}
